import type { FormatCategoryWithOther } from "@garimpa/lib/formatGroups";
import { parseFormatSetValue } from "@garimpa/lib/parseFormatSetValue";

export function formatFormatSetValue(
  value: string,
  formatLabel: (format: FormatCategoryWithOther) => string,
): string {
  const item = parseFormatSetValue(value);
  return item ? `${item.quantity}× ${formatLabel(item.format)}` : value;
}
